function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("path", {
  d: "M12.5,4.51v0a.46.46,0,0,1-.23.4L8.35,8.85a.48.48,0,0,1-.7,0,.48.48,0,0,1,0-.7L10.77,5H.5a.5.5,0,0,1-.5-.5A.5.5,0,0,1,.5,4H10.82L7.65.85a.48.48,0,0,1,0-.7.48.48,0,0,1,.7,0l4,4A.51.51,0,0,1,12.5,4.51Zm0,8.71a.5.5,0,0,1-.5.5H1.68L4.85,16.9a.48.48,0,0,1,0,.7.48.48,0,0,1-.7,0l-4-4A.51.51,0,0,1,0,13.24v0a.46.46,0,0,1,.23-.4L4.15,8.9a.49.49,0,0,1,.7.7L1.73,12.72H12A.5.5,0,0,1,12.5,13.22Z"
})));

var SvgPayouts = function SvgPayouts(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 12.5 17.75",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgPayouts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/payouts.a2a218ad.svg";
export { ForwardRef as ReactComponent };